import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { Provider } from 'react-redux';
import '@tmapy/style-guide/dist/sass/_global.scss';
import './sass/default.scss';
import { SvgArrowLeft, SvgArrowRight, SecondaryBtn, CloseDialogBtn, StickyFooter, TertiaryBtn, SvgCross, } from '@tmapy/style-guide';
import { initializeStore } from './store';
import { ActionBar } from './actionbar';
import { Preview } from './preview';
import { FormBuilder } from './componentsbuilder';
import { PageOption } from './pageoption';
import { PagePartHeader, PagePartFooter } from './pageparts';
import { TemplateOption } from './templateoption';
import { changePageTemplate, changeConfig, changePageMargins, changePageSize, changePageOrientation, } from './actions';
import { locale as sysLocale } from './locale';
import { LocaleContext } from './LocaleContext';
export const Repex = ({ config, lg = 'cz', onCloseBtnClick }) => {
    const [isSettingsShown, setSettingsShown] = useState(false);
    const [store] = useState(() => {
        return initializeStore({ config });
    });
    const containerRef = useRef(null);
    const previewParentRef = useRef(null);
    const locale = {
        ...sysLocale[lg.toLowerCase()],
        ...config.locale,
    };
    useEffect(() => {
        // init first template
        if (config.defaultTemplate !== undefined) {
            store.dispatch(changePageTemplate(config.defaultTemplate));
        }
        if (config.margins !== undefined) {
            store.dispatch(changePageMargins(config.margins));
        }
        if (config.size !== undefined) {
            store.dispatch(changePageSize(config.size));
        }
        if (config.orientation !== undefined) {
            store.dispatch(changePageOrientation(config.orientation));
        }
        containerRef?.current?.focus();
    }, []);
    useEffect(() => {
        store.dispatch(changeConfig(config));
    }, [config]);
    const handleKeyDown = (e) => {
        // Prevent Ctrl + P
        if (process.env.NODE_ENV === 'production' &&
            e.ctrlKey &&
            (e.key === 'p' || e.charCode === 16 || e.charCode === 112 || e.keyCode === 80)) {
            alert(locale.alertMsg);
            e.preventDefault();
        }
    };
    const handleToggleViewBtnClick = () => {
        setSettingsShown(!isSettingsShown);
    };
    const settingsIcon = {
        position: isSettingsShown ? 'left' : 'right',
        element: isSettingsShown ? _jsx(SvgArrowLeft, {}) : _jsx(SvgArrowRight, {}),
    };
    return (_jsx(Provider, { store: store, children: _jsx(LocaleContext.Provider, { value: { locale }, children: _jsxs("div", { ref: containerRef, id: 'rpx-container', className: classNames({
                    'rpx-layout': true,
                    'rpx-layout-isSettingsShown': isSettingsShown,
                }), tabIndex: 0, onKeyDown: handleKeyDown, children: [_jsx("div", { className: 'rpx-layout--header sg-a-px-2', children: _jsxs("div", { className: 'sg-a-d-f sg-a-jc-sb sg-a-cg-2 sg-a-py-1 sg-u-bb', children: [_jsx(SecondaryBtn, { icon: settingsIcon, onClick: handleToggleViewBtnClick, children: isSettingsShown
                                        ? locale.moduleOptions.previewPart
                                        : locale.moduleOptions.settingsPart }), _jsx(TertiaryBtn, { isDanger: true, icon: { element: _jsx(SvgCross, {}) }, tooltip: locale.close, onClick: onCloseBtnClick })] }) }), _jsxs("div", { className: 'rpx-layout--main', children: [_jsxs("div", { className: 'rpx-layout--preview', id: 'rpx-print-content', ref: previewParentRef, children: [_jsx(Preview, { parentRef: previewParentRef }), _jsx(PagePartHeader, {}), _jsx(PagePartFooter, {})] }), _jsxs("div", { className: 'rpx-layout--settings', children: [_jsx(CloseDialogBtn, { tooltip: locale.close, onClick: onCloseBtnClick }), _jsxs("div", { className: 'rpx-settings', children: [_jsxs("div", { className: 'sg-u-vs-2', children: [_jsx(TemplateOption, {}), _jsx(PageOption, {}), _jsx(FormBuilder, {})] }), _jsx(StickyFooter, { children: _jsx(ActionBar, {}) })] })] })] }), _jsx("div", { className: 'rpx-layout--footer sg-a-pl-2 sg-a-pr-2', children: _jsx("div", { className: 'sg-a-py-1 sg-u-bt', children: _jsx(ActionBar, {}) }) })] }) }) }));
};
export default Repex;
//# sourceMappingURL=index.js.map